import type { MonthlyCostSummary } from "@sitescene/types";

import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";
import { ENDPOINTS } from "@/api/endpoints";
import { queryKeys } from "@/api/query-keys";
import { useOrgSelection } from "@/context/use-org-selection";

/** VLM spend of the selected organization for one "YYYY-MM" month (UTC). */
export const useMonthlyCosts = (month: string) => {
	const { selected } = useOrgSelection();
	const orgCode = selected?.orgCode ?? null;

	return useQuery({
		enabled: orgCode !== null,
		queryFn: async () => {
			const response = await apiClient.get<MonthlyCostSummary>(
				ENDPOINTS.shadow.costs,
				{ params: { month } },
			);
			return response.data;
		},
		queryKey: queryKeys.costs(orgCode ?? "", month),
	});
};
